import {
  ChangeDetectionStrategy,
  Component,
  Input,
  HostBinding,
} from "@angular/core";
import { UI } from "../../../services/ui.service";

@Component({
  selector: "go-live-button",
  templateUrl: "./goLiveButton.component.html",
  styleUrls: ["./goLiveButton.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GoLiveButtonComponent {
  @Input()
  @HostBinding("class.live")
  isLive: boolean = false;

  title: string = "Go Live";

  /* Saving services */
  constructor(private ui: UI) {}

  /**
   * Going live or stop live broadcast
   * @retrun void
   */
  goLiveToggle() {
    this.isLive = !this.isLive;

    this.title = this.isLive ? "Stop Live" : "Go Live";

    this.ui.EVENTS.LiveStatusDidChange.next(this.isLive);
  }
}
